import { render, staticRenderFns } from "./list_config.vue?vue&type=template&id=7527324b"
import script from "./list_config.vue?vue&type=script&lang=js"
export * from "./list_config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7527324b')) {
      api.createRecord('7527324b', component.options)
    } else {
      api.reload('7527324b', component.options)
    }
    module.hot.accept("./list_config.vue?vue&type=template&id=7527324b", function () {
      api.rerender('7527324b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/customform/list_config.vue"
export default component.exports